export const keywords =
  'itr 2 filing, itr 2 e filing, itr 2 online return filing, itr 2 filing online 2022-23, itr 2 filing steps, e filing itr 2, e filing itr 2 form, itr 2 filing cleartax, cleartax itr 2 filing charges, itr 2 filing procedure';

export const canonical = 'https://cleartax.in/itr-2-filing/';

export const description =
  'ITR 2 Filing for FY 2022-23 (AY 2023-24): Effortlessly file ITR 2 online for capital gains, NRI income, foreign income, ESOP, income from house property and agricultural income.';

export const pageTitle =
  'ITR 2 Filing for FY 2022-23 (AY 2023-24) | ITR 2 Filing Online for Capital Gains, NRI & Foreign Income - ClearTax';
